define('rest/geocode',["http", "./utils", "security"],
    function (http, utils, security) {
        "use strict";

        var queryParamNames = [
            "storeResult", "typeahead", "limit", "ofs", "lat", "lon", "countrySet", "radius", "topLeft", "btmRight"
        ];

        return {
            geocode: function (options, callback) {
                var pathParams = {}, queryParams = {};

                pathParams.query = utils.required(options.query, "\"query\" parameter is required for geocode service.");
                queryParams.key = utils.or(options.key, security.getKey("services/search"));

                var baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/");
                var serviceUrl = utils.or(options.serviceUrl, "search/2/geocode/{query}.{contentType}");

                utils.extractQueryParams(options, queryParams, queryParamNames);
                http.get({
                    url: baseUrl + serviceUrl,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: "callback",
                    fail: options.fail
                });
            }
        };
    }
);
